'use client'

import toast, { ToastBar, Toaster } from 'react-hot-toast'
import { XCloseIcon } from 'primitives/icons'
import { Typography } from '@repo/design-system-cf/components/typography'
import { IconWarning, IconCheckCircle } from '@repo/design-system-cf/components/icons'

export function ClubhouseToaster() {
  return (
    <div className="relative h-px">
      <Toaster
        position="top-right"
        containerStyle={{
          position: 'fixed', // override default 'fixed'
          top: 100,
        }}
        toastOptions={{
          success: {
            style: { borderLeft: '8px solid #0EAD5B', backgroundColor: '#E7FDF1', margin: 0 },
          },
          error: {
            style: { borderLeft: '8px solid #B5162D', backgroundColor: '#FCE7EA', margin: 0 },
          },
        }}
      >
        {t => (
          <ToastBar
            toast={t}
            style={{
              ...t.style,
              animation: t.visible
                ? 'enterFromRight 300ms ease-out forwards'
                : 'exitToRight 300ms ease-in forwards',
            }}
          >
            {({ message }) => (
              <div className="flex justify-start items-center w-full h-full">
                {t.type === 'error' ? <IconWarning className="text-cf-red-600 size-4 " /> : null}
                {t.type === 'success' ? (
                  <IconCheckCircle className="text-[#0EAD5B] size-4 " />
                ) : null}

                <Typography variant="cf-heading-01">{message}</Typography>
                {t.type !== 'loading' ? (
                  <div className="ml-auto flex flex-col items-start h-full">
                    <button onClick={() => toast.dismiss(t.id)}>
                      <XCloseIcon />
                    </button>
                  </div>
                ) : null}
              </div>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  )
}
